<template>
  <v-container>
    <!-- Company Name Header -->
    <h1>Settings for {{ getSelectedCompany?.name }}</h1>
    
    <v-expansion-panels class="mt-4">
      <!-- Menu Editor Panel -->
      <v-expansion-panel id="menu-editor-panel">
        <v-expansion-panel-title>Jail Call Menu Editor</v-expansion-panel-title>
        <v-expansion-panel-text>
          <JailCallMenuEditor 
            :company="getSelectedCompany"
            @update:company="handleCompanyUpdate"
            @show-dialog="showDialog"
          />
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Voicemail and Forwarding Panel -->
      <v-expansion-panel id="voicemail-panel">
        <v-expansion-panel-title>Voicemail and Forwarding</v-expansion-panel-title>
        <v-expansion-panel-text>
          <VoicemailForwarding
            :company="getSelectedCompany"
            @update:company="handleCompanyUpdate"
            @show-dialog="showDialog"
          />
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Notifications Panel -->
      <v-expansion-panel id="notifications-panel">
        <v-expansion-panel-title>Text and Email Notifications</v-expansion-panel-title>
        <v-expansion-panel-text>
          <NotificationDetails 
            :company="getSelectedCompany"
            @update:company="handleCompanyUpdate"
            @show-dialog="showDialog"
          />
        </v-expansion-panel-text>
      </v-expansion-panel>

      <!-- Language and Options Panel -->
      <v-expansion-panel id="language-options-panel">
        <v-expansion-panel-title>Language and Other Options</v-expansion-panel-title>
        <v-expansion-panel-text>
          <LanguageAndOtherOptions 
            :company="getSelectedCompany"
            @update:company="handleCompanyUpdate"
            @show-dialog="showDialog"
          />
        </v-expansion-panel-text>
      </v-expansion-panel>

    </v-expansion-panels>
  </v-container>
</template>

<script>
import { getCurrentInstance } from 'vue';
import { mapState, mapGetters } from 'vuex';
import JailCallMenuEditor from './Settings-JailCallMenuEditor.vue';
import VoicemailForwarding from './Settings-VoicemailForwarding.vue';
import NotificationDetails from './Settings-NotificationDetails.vue';
import LanguageAndOtherOptions from './Settings-LanguageAndOtherOptions.vue';

export default {
  name: 'SettingsPage',
  components: {
    JailCallMenuEditor,
    VoicemailForwarding,
    NotificationDetails,
    LanguageAndOtherOptions
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['userRole', 'getSelectedUser', 'getSelectedCompany'])
  },
  setup() {
    const { proxy } = getCurrentInstance();

    const handleCompanyUpdate = async (updates) => {
      await proxy.$store.dispatch('updateSelectedCompany', updates);
    };

    const showDialog = async (message) => {
      await proxy.$showOkDialog('', message, null);
    };

    return {
      handleCompanyUpdate,
      showDialog
    };
  }
};
</script>


<style scoped>

#notifications-panel {
  margin-bottom: 28px;
}

#language-options-panel {
  margin-bottom: 28px;
}

:deep(#menu-edit-panel) {
  margin-bottom: 22px;
}

.show-dialog {
  background-color: #d2b48c;
}

:deep(.v-expansion-panels > .v-expansion-panel > .v-expansion-panel-title) {
  font-size: 1.25rem !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  background-color: #d2b48c !important;
  border: 1px solid #d2b48c !important;
}

:deep(.v-expansion-panels > .v-expansion-panel > .v-expansion-panel-title .v-expansion-panel-title__icon .v-icon) {
  color: #ffffff !important;
}

:deep(.v-expansion-panel-text) {
  background-color: #f5f5dc !important;
  border: 1px solid #d2b48c !important;
  border-top: none !important;
}

:deep(#menu-edit-panel) {
  margin-bottom: 22px;
}

.show-dialog {
  background-color: #d2b48c;
}

.accordion-container {
  background-color: #f5f5dc;
  padding: 20px;
  border-radius: 8px;
}

.prompts-container {
  min-height: 400px;
}

.button-row {
  display: flex;
  gap: 12px;
}

.action-button {
  background-color: #d2b48c !important;
  color: white !important;
  transition: background-color 0.3s ease !important;
}

.action-button:hover {
  background-color: #635347 !important;
}

.kebab-handle {
  cursor: move;
  font-size: 16px;
  line-height: 1;
  opacity: 0.7;
  padding: 8px 4px;
}

.kebab-handle.disabled {
  cursor: default;
  opacity: 0.3;
}

.edit-icon {
  opacity: 0.3;
  transition: opacity 0.2s ease;
}

.edit-icon:hover {
  opacity: 1;
}

:deep(.v-expansion-panel) {
  position: relative;
  z-index: 1;
  margin-bottom: 8px;
}

.ghost {
  opacity: 0.8;
  background-color: #7f735e;
  z-index: 3;
}

:deep(.v-expansion-panel),
:deep(.v-expansion-panel-title) {
  transition: background-color 0.2s ease;
}

:deep(.v-expansion-panel-title) {
  cursor: pointer !important;
}

.left-section {
  position: relative;
  z-index: 1001;
}

.kebab-menu {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #8b4513;
  padding: 4px 8px;
  margin: 0 12px;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.kebab-menu:hover {
  opacity: 1;
}

.kebab-menu-dropdown {
  position: absolute;
  background-color: white;
  border: 1px solid #d2b48c;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 5px 0;
  z-index: 1000;
  left: 45px;
  top: 0;
  min-width: 120px;
  transform: translateY(-25%);
}

.kebab-menu-dropdown button {
  display: block;
  width: 100%;
  padding: 8px 20px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
}

.kebab-menu-dropdown button:hover {
  background-color: #f5f5dc;
}

.accordion-item {
  transition: all 0.3s ease-out;
  transform-origin: top;
  opacity: 1;
  transform: scale(1);
}

.deletion-animation {
  opacity: 0;
  transform: scale(0.8);
}

.addition-animation {
  animation: addItem 0.3s ease-out;
}

@keyframes addItem {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.dragging {
  opacity: 0.4;
}

:deep(.v-text-field input) {
  font-size: 15px !important;
}

.item-title {
  line-height: 20px;
  font-size: 15px;
}

.translation-container {
  padding-left: 74px;
}

.translation-item {
  font-size: 15px;
  position: relative;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}

.translation-item:last-child {
  margin-bottom: 0;
}

.test-button {
  display: none;
}

.translation-button {
  position: absolute !important;
  left: -93px !important;
  top: -2px !important;
  transform: translateY(-50%) !important;
  background-color: #f5deb3 !important;
  height: 50px !important;
  min-width: 32px !important;
  font-size: 10px !important;
  line-height: 1.2 !important;
  padding: 4px !important;
}

/* Expansion Panel Styles - Updated to apply to all panels */
:deep(.v-expansion-panel-title) {
  min-height: 64px !important;
  padding: 16px !important;
}

:deep(.v-expansion-panel-title__overlay) {
  height: 64px !important;
}

/* Updated to target all panels */
:deep(.v-expansion-panels > .v-expansion-panel > .v-expansion-panel-title) {
  font-size: 1.25rem !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  background-color: #d2b48c !important;
  border: 1px solid #d2b48c !important;
}

/* Updated to target all expansion panel arrow icons */
:deep(.v-expansion-panels > .v-expansion-panel > .v-expansion-panel-title .v-expansion-panel-title__icon .v-icon) {
  color: #ffffff !important;
}

/* Inner menu item arrows - dark orange */
:deep(.draggable .v-expansion-panels .v-expansion-panel .v-expansion-panel-title .v-expansion-panel-title__icon .v-icon), 
:deep(.accordion-container .v-expansion-panels .v-expansion-panel .v-expansion-panel-title .v-expansion-panel-title__icon .v-icon) {
  color: #8b4513 !important;
}

:deep(.v-expansion-panel-text) {
  background-color: #f5f5dc !important;
  border: 1px solid #d2b48c !important;
  border-top: none !important;
}

/* Menu item panel styles - Updated to apply to both panels */
:deep(.accordion-container .v-expansion-panels .v-expansion-panel > .v-expansion-panel-title),
:deep(.accordion-container .v-expansion-panels .v-expansion-panel > .v-expansion-panel-text) {
  background-color: #ffffff !important;
  color: #424242 !important;
}

:deep(.accordion-container .v-expansion-panels .v-expansion-panel > .v-expansion-panel-title:hover) {
  background-color: #f5f5f5 !important;
}

.voicemail-text, 
.translation-text {
  min-height: 180px;
  white-space: pre-wrap;
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  padding: 12px;
  width: 100%;
  background-color: white;
}

:deep(.v-textarea .v-field__input) {
  min-height: 180px !important;
  white-space: pre-wrap;
}

#menu-editor-panel {
  margin-bottom: 28px;
}

#voicemail-panel {
  margin-bottom: 28px;
}

@media (max-width: 600px) {

  #menu-editor-panel .accordion-container {
    padding: 0;
  }

  :deep(#voicemail-panel .v-expansion-panel-text__wrapper) {
    padding: 0;
  }

  :deep(#voicemail-panel  div.radio-group.mt-4.ms-8) {
    margin-inline-start: 12px !important
  }

  :deep(#voicemail-panel .v-col-3) {
    flex: 0 0 70% !important;
    max-width: 70% !important;
  }


  :deep(#voicemail-panel div.ms-8.mt-4.vm-prompt) {
    margin-inline-start: 12px !important  
  }

}
</style>

